import type { Game, GameTrackingMeta, GameTrackingOrigin } from '@game/types'
import { useRoute } from '#imports'
import { trackGameOpen } from '@game/utils/tracking'

export interface UseGameOpenTrackingReturn {
    trackGameOpen: (origin: GameTrackingOrigin, game: Pick<Game, 'slug'>, meta?: GameTrackingMeta) => void
}

/**
 * `trackGameOpen` stamped with the route the component was set up on, so a
 * click during a pending navigation carries the owning page, not the live
 * route. Not for components that persist across routes (layout heroes).
 */
export function useGameOpenTracking(): UseGameOpenTrackingReturn {
    const url = useRoute().path

    return {
        trackGameOpen: (origin, game, meta) => trackGameOpen(origin, game, { url, ...meta }),
    }
}
